














import axios from "@/libs/axios";
import { BButton, BSpinner } from "bootstrap-vue";
import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useCustomersStore } from "@/store/useCustomersStore";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
const { createHash } = require("crypto");
import { getInstance } from "@/auth/auth0";

export default defineComponent({
    components: { BButton, BSpinner },
    setup() {
        const initialDisabled = ref(true);
        const whatsappChannels = ref(null);

        const fetchWhatsappChannels = () => {
            return axios
                .get("channels", {
                    params: {
                        fields: "name,provider,platform,identity,active",
                        s: {
                            $or: [{ platform: { $cont: "whatsapp" } }, { provider: { $cont: "bird" } }],
                        },
                    },
                })
                .then((res) => {
                    whatsappChannels.value = res.data;

                    initialDisabled.value = false;
                });
        };
        fetchWhatsappChannels();

        const hasReachedLimit = computed(() => {
            const { customerSettings } = storeToRefs(useCustomersStore());

            const channels = whatsappChannels.value?.filter(
                (channel) => channel.provider === "chatwoot" && channel.platform === "web"
            );

            return channels?.length >= customerSettings.value.chatwootLimit;
        });

        const hasEnvConfiguration = () => {
            return !!(
                process.env.VUE_APP_META_APP_ID &&
                process.env.VUE_APP_META_APP_SECRET &&
                process.env.VUE_APP_META_CONFIG_ID
            );
        };

        const isButtonDisabled = computed(() => {
            return hasReachedLimit.value || !hasEnvConfiguration();
        });

        const toast = useToast();
        const openPopup = async () => {
            const accessToken = (await getInstance().auth0Client.getTokenSilently({ detailedResponse: true }))
                ?.id_token;
            console.log("===============accessToken================");
            console.log(accessToken);

            const base64Url = accessToken.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                window
                    .atob(base64)
                    .split("")
                    .map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );

            const parsedPayload = JSON.parse(jsonPayload);
            const secret = createHash("sha256")
                .update(`${parsedPayload["https://schemas.saysimple.io/customerId"]}AA4VvCEJD3R4N2PbBLKWX`)
                .digest("hex");
            console.log(parsedPayload["https://schemas.saysimple.io/customerId"]);

            window.open(
                `https://chat.saysimple.io/autologin/${parsedPayload["https://schemas.saysimple.io/customerId"]}/${secret}/${accessToken}`
            );
        };

        const buttonTitle = computed(() => {
            if (!hasEnvConfiguration()) {
                return "No valid configuration found for embedded signup. Please contact Saysimple.";
            }

            if (hasReachedLimit.value) {
                return i18n.t("embedded-signup.limit-reached");
            }
        });

        return {
            buttonTitle,
            hasReachedLimit,
            initialDisabled,
            isButtonDisabled,
            openPopup,
        };
    },
});
